interface Props {
  mainColor: string
}

const Glow = ({ mainColor }: Props) => {
  return (
    <div className="absolute left-0 top-0 z-0 h-auto w-full">
      <svg xmlns="http://www.w3.org/2000/svg" width="190" height="240" viewBox="0 0 190 240" fill="none">
        <g filter="url(#filter0_f_66_14863)">
          <circle cx="95" cy="49.4617" r="70" fill={`${mainColor}`} />
        </g>
        <defs>
          <filter
            id="filter0_f_66_14863"
            x="-95"
            y="-140.538"
            width="380"
            height="380"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="60" result="effect1_foregroundBlur_66_14863" />
          </filter>
        </defs>
      </svg>
    </div>
  )
}

export default Glow
